function addMoreBlogClickHandler() {
    $(".load-more-blog > a").click(function (ev) {
        ev.preventDefault();
        loadMoreBlog(this);
    });
}

function loadMoreBlog(link) {
    let $parent = $(link).closest(".load-more-blog");
    let $container = $parent.parent();
    $parent.addClass("loading");
    let $blogList = $container.closest(".blog-list");
    let url = $parent.data("url") + "&begin=" + $blogList.children().length
        +  "&_=" + new Date().getTime();
    $.get(url, function (data) {
        $container.remove();
        $blogList.append($(data).hide().fadeIn());
        addMoreBlogClickHandler();
        initMoreVideos();
    })
        .fail(function () {
            $container.remove();
            $blogList.append("<p>Error retrieving data.</p>");
        });
}

function initBlog() {
    let $blogResultContainer = $('.blog-list');
    if ($blogResultContainer.length) {
        addMoreBlogClickHandler();
    }
}